<template>
  <Modal
    buttons-class="row justify-center q-pa-md"
    hide-close-button
    :modal-style="{ maxWidth: '280px' }"
  >
    <div class="column full-width full-height container">
      <div class="row bg-hover-background banner" />
      <div class="image-container q-pl-lg">
        <QIcon
          name="img:https://assets.streem.com.au/icons/instant-edit-download-processing.svg"
          size="50px"
        />
      </div>
      <div class="row description-text justify-center text-center">
        <i18n-t
          keypath="modals.create_instant_download_confirm_modal.text"
          scope="global"
          tag="div"
        >
          <template #type>
            {{ type }}
          </template>
          <template #newline>
            <br />
          </template>
        </i18n-t>
      </div>
      <div class="row justify-center" />
    </div>
    <template #buttons>
      <BaseButton
        color="primary"
        :label="$t('global.done')"
        new-design
        @click="confirm"
      />
    </template>
  </Modal>
</template>

<script>
import { getLocaleText } from "shared/boot/i18n";
import { BaseButton } from "shared/components/base";
import Modal from "shared/components/core/modals/Modal.vue";

export default {
  name: "CreateInstantDownloadConfirmModal",
  components: {
    Modal,
    BaseButton,
  },
  props: {
    type: {
      type: String,
      default: () =>
        getLocaleText(
          "modals.create_instant_download_confirm_modal.default_type"
        ),
    },
  },
  emits: ["confirm"],
  methods: {
    confirm() {
      this.$emit("confirm");
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  position: relative;
}

.image-container {
  position: absolute;
  left: 50%;
  top: 32%;
  transform: translate(-50%, -50%);
}

.banner {
  height: 72px;
  margin: -16px -16px 0;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  margin-bottom: 16px;
}

.description-text {
  line-height: 130%;
  font-weight: 500;
  color: var(--s-color-denim-9);
  background-color: $white;
}

:deep(.streem-modal2-buttons) {
  padding-top: 0;
  border-top: none !important;
}
</style>
